import { MERCHANT_HOURS_ACTIONS } from "../../constants/merchantHoursActionsType";

export const merchantHoursInitialState = {
    days: [
        {
            name: 'Lunes',
            value: 'monday'
        },
        {
            name: 'Martes',
            value: 'tuesday'
        },
        {
            name: 'Miércoles',
            value: 'wednesday'
        },
        {
            name: 'Jueves',
            value: 'thursday'
        },
        {
            name: 'Viernes',
            value: 'friday'
        },
        {
            name: 'Sábado',
            value: 'saturday'
        },
        {
            name: 'Domingo',
            value: 'sunday'
        }
    ],
    workingDays: {},
    calendarEvents: [],
    currentStores: [],
    loadingState: {
        calendarEvents: false,
        workingDays: false,
        calendarModal: false,
        fullDelete: false
    },
    errors: {
        calendarEvents: false,
        workingDays: false,
        calendarModal: false,
        fullDelete: false
    },
    lastSave: null
};

const editOrSaveWorkingDay = ({ day = '', state = {}, data = {}, additionalData = {} }) => {
    return ({
        ...state.workingDays,
        [day]: {
            ...state.workingDays[day],
            ...data,
            ...additionalData,
        }
    })
}

const deleteAndGetWorkingDay = (workingDay, currentWorkingDays = {}) => {
    let day = Object.keys(workingDay).find(dayName => dayName)
    delete currentWorkingDays[day]
    return currentWorkingDays
}

const editOrSaveCalendarEvent = ({ fromDate, toDate, isSingleDate, closingReason, isServiceAvailable, id }, calendarEvents = []) => {
    const CALENDAR_EVENT_EMPTY_QUANTITY  = 0

    const calendarEventFoundIndex = calendarEvents
        .findIndex(({ id: calendarEventId }) => calendarEventId === id)

    const calendarEvent = { fromDate, toDate, isSingleDate, closingReason, isServiceAvailable, id }

    const isCalendarEventFound = calendarEventFoundIndex >= CALENDAR_EVENT_EMPTY_QUANTITY

    if (isCalendarEventFound) calendarEvents[calendarEventFoundIndex] = calendarEvent

    return [...calendarEvents, ...isCalendarEventFound ? [] : [calendarEvent]]
}

const deleteCalendarEvent = ({ id }, calendarEvents) => {
    const calendarEventIndex = calendarEvents.findIndex(({ id: calendarEventId }) => calendarEventId === id)
    calendarEvents.splice(calendarEventIndex, 1)
    return [...calendarEvents]
}
  
export const merchantHoursReducer = (
    state = merchantHoursInitialState,
    { type, data }
  ) => {
    switch (type) {
        case MERCHANT_HOURS_ACTIONS.SET_INITIAL_STATE:
            return merchantHoursInitialState
        case MERCHANT_HOURS_ACTIONS.SET_LAST_SAVE:
            return {
                ...state,
                lastSave: new Date()
            }
        case MERCHANT_HOURS_ACTIONS.SET_ERROR_STATE:
            const { type, message } = data
            return {
                ...state,
                loadingState: {
                    ...state.loadingState,
                    [type]: !state.loadingState[type]
                },
                errors: {
                    [type]: message
                }
            }
        case MERCHANT_HOURS_ACTIONS.TOGGLE_LOADING_STATE:
            const { loadingType, force: forceState } = data
            return {
                ...state,
                loadingState: {
                    ...state.loadingState,
                    [loadingType]: forceState !== undefined ? forceState : !state.loadingState[loadingType]
                }
            }
        case MERCHANT_HOURS_ACTIONS.SET_WORKING_DAY: 
            const day = Object.keys(data).find(dayName => dayName)
            return {
                ...state,
                workingDays: editOrSaveWorkingDay({ day, state, data: data[day] }),
                errors: merchantHoursInitialState.errors
            }
        case MERCHANT_HOURS_ACTIONS.DELETE_WORKING_DAY:
            return {
                ...state,
                workingDays: {
                    ...deleteAndGetWorkingDay(data, state.workingDays)
                },
                errors: merchantHoursInitialState.errors
            }
        case MERCHANT_HOURS_ACTIONS.SET_INITIAL_CALENDAR_EVENTS:
            return {
                ...state,
                calendarEvents: data
            }
        case MERCHANT_HOURS_ACTIONS.SET_CALENDAR_EVENTS:
            return {
                ...state,
                calendarEvents: editOrSaveCalendarEvent(data, state.calendarEvents),
                errors: merchantHoursInitialState.errors
            }
        case MERCHANT_HOURS_ACTIONS.DELETE_CALENDAR_EVENTS:
            return {
                ...state,
                calendarEvents: deleteCalendarEvent(data, state.calendarEvents),
                errors: merchantHoursInitialState.errors
            }
        case MERCHANT_HOURS_ACTIONS.SET_CURRENT_STORES:
            return {
                ...state,
                currentStores: data
            }
        default:
            return state
  }
}
  